// extracted by mini-css-extract-plugin
export default {"baloon":"Baloon_baloon__sKVaZ","left":"Baloon_left__cg17Y","right":"Baloon_right__9zAsT","btn":"Baloon_btn__aGsRd"};